import { render, staticRenderFns } from "./IfrssSummaryTable.vue?vue&type=template&id=630987e1"
import script from "./IfrssSummaryTable.vue?vue&type=script&lang=js"
export * from "./IfrssSummaryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports